import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = [".open", "title"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = ["value", "placeholder", "label"]
const _hoisted_4 = { slot: "footer" }
const _hoisted_5 = { class: "discard-message" }
const _hoisted_6 = ["disabled"]

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { validateKubernetesName } from '@shell/utils/validators/kubernetes-name';
import Banner from '@components/Banner/Banner.vue';
import { useCreateNamespace } from '../../queries/useNamespaceMutations';


export default /*@__PURE__*/_defineComponent({
  __name: 'NamespaceModal',
  setup(__props, { expose: __expose }) {

const store = useStore() as any;
const t = store.getters['i18n/t'];

// Modal open state
const showModal = ref(false);

// Form fields (separate from the model to avoid proxy mutation issues)
const newNamespaceInput = ref<HTMLElement | null>(null);
const newNamespaceName = ref<string>('');

const {mutate: createNamespace, isPending: isCreatingNamespace, isError: createNamespaceError, error: createNamespaceErrorData} = useCreateNamespace(store, closeModal);

const showDiscardConfirm = ref(false);

function getNamespaceErrors(name: string) {
  const kubernetesErrors = validateKubernetesName(
    name || '',
    t('epinio.namespace.name'),
    store.getters,
    undefined,
    [],
  );

  if (kubernetesErrors.length) {
    return [kubernetesErrors.join(', ')];
  }

  const validateName = name.match(/[a-z0-9]([-a-z0-9]*[a-z0-9])?/);

  if (
    !validateName ||
    validateName[0] !== name
  ) {
    return [t('epinio.namespace.validations.name')];
  }

  return [];
}

const validationPassed = computed(() => {
 if (!newNamespaceName.value?.length) {
    return false;
  }

  const validationErrors = getNamespaceErrors(newNamespaceName.value);

  return validationErrors.length === 0;
});

function openCreate() {
  showModal.value = true;
}

function handleModalClose() {
  if (newNamespaceName.value.length > 0) {
    showDiscardConfirm.value = true;
  } else {
    closeModal();
  }
}

function handleKeepEditing() {
  showDiscardConfirm.value = false;
}

function handleDiscard() {
  showDiscardConfirm.value = false;
  closeModal();
}

function closeModal() {
  showModal.value = false;
  newNamespaceName.value = '';
}

async function onSubmit() {
  createNamespace({ name: newNamespaceName.value });
}

__expose({ openCreate });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-modal", {
    ".open": showModal.value,
    title: _unref(t)('epinio.namespace.create'),
    dismissible: false,
    onModalOpen: _cache[2] || (_cache[2] = () => newNamespaceInput.value?.focus()),
    onModalClose: closeModal
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("trailhand-text-input", {
        ref_key: "newNamespaceInput",
        ref: newNamespaceInput,
        value: newNamespaceName.value,
        placeholder: _unref(t)('epinio.namespace.placeholders.name'),
        label: _unref(t)('epinio.namespace.name'),
        required: true,
        size: "large",
        onTextInputChange: _cache[0] || (_cache[0] = ($event: any) => (newNamespaceName.value = $event.detail.value)),
        onKeydown: _cache[1] || (_cache[1] = (e) => { if (e.key === 'Enter' && validationPassed.value) onSubmit(); })
      }, null, 40, _hoisted_3),
      _cache[3] || (_cache[3] = _createTextVNode()),
      (_unref(createNamespaceError))
        ? (_openBlock(), _createBlock(Banner, {
            key: 0,
            color: "error",
            label: _unref(createNamespaceErrorData)?.message || _unref(t)('epinio.namespace.errors.create')
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createElementVNode("div", _hoisted_4, [
      (showDiscardConfirm.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('epinio.unsavedChanges.warning')), 1),
            _cache[4] || (_cache[4] = _createTextVNode()),
            _createElementVNode("trailhand-button", {
              variant: "secondary",
              class: "mr-10",
              onButtonClick: handleKeepEditing
            }, _toDisplayString(_unref(t)('generic.keepEditing')), 33),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _createElementVNode("trailhand-button", {
              variant: "destructive",
              onButtonClick: handleDiscard
            }, _toDisplayString(_unref(t)('generic.discard')), 33)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("trailhand-button", {
              variant: "secondary",
              class: "mr-10",
              onButtonClick: handleModalClose
            }, _toDisplayString(_unref(t)('generic.cancel')), 33),
            _cache[6] || (_cache[6] = _createTextVNode()),
            _createElementVNode("trailhand-button", {
              variant: "primary",
              disabled: !validationPassed.value || _unref(isCreatingNamespace),
              onButtonClick: onSubmit
            }, _toDisplayString(_unref(isCreatingNamespace) ? _unref(t)('generic.creating') : _unref(t)('generic.create')), 41, _hoisted_6)
          ], 64))
    ])
  ], 40, _hoisted_1))
}
}

})